import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class ShortLinkAPI extends BaseAPI {}

export default new ShortLinkAPI('v1/short-links', 'ShortLink', getApiUrl(apis.CommonAPI))
